/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Field { 
    section?: string;
    name?: string;
    type?: Field.TypeEnum;
    visibility?: Field.VisibilityEnum;
    permission?: Field.PermissionEnum;
    validation?: string;
    required?: boolean;
    sortOrder?: number;
    source?: Field.SourceEnum;
}
export namespace Field {
    export type TypeEnum = 'STRING' | 'NUMBER' | 'DATE' | 'LIST';
    export const TypeEnum = {
        String: 'STRING' as TypeEnum,
        Number: 'NUMBER' as TypeEnum,
        Date: 'DATE' as TypeEnum,
        List: 'LIST' as TypeEnum
    };
    export type VisibilityEnum = 'HIDE_ALWAYS' | 'HIDE_WHEN_EMPTY';
    export const VisibilityEnum = {
        Always: 'HIDE_ALWAYS' as VisibilityEnum,
        WhenEmpty: 'HIDE_WHEN_EMPTY' as VisibilityEnum
    };
    export type PermissionEnum = 'RO' | 'RW';
    export const PermissionEnum = {
        Ro: 'RO' as PermissionEnum,
        Rw: 'RW' as PermissionEnum
    };
    export type SourceEnum = 'PERSON_DATA' | 'SIGNER_ADDITIONAL_DATA' | 'DOSSIER_ADDITIONAL_DATA';
    export const SourceEnum = {
        PersonData: 'PERSON_DATA' as SourceEnum,
        SignerAdditionalData: 'SIGNER_ADDITIONAL_DATA' as SourceEnum,
        DossierAdditionalData: 'DOSSIER_ADDITIONAL_DATA' as SourceEnum
    };
}


